import React, { useState, useEffect, useRef } from 'react'
import { WMSTileLayer, MapContainer, TileLayer, LayerGroup, Map, LayersControl, ZoomControl, ScaleControl, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import Watermark from '../components/map/Watermark';
import BaseLayersComponent from '../components/map/BaseLayersComponent';
import InitialPositionButton from '../components/map/InitialPositionButton';
import './Map.css'

export default function MapComponent(props) {

  return (
    <>
      <MapContainer
        center={props.position}
        zoom={props.zoom}
        scrollWheelZoom={true}
        zoomControl={false}
        className='container-fluid'
        style={{ width: '100hw', height: props.height ? props.height : '55vh', position: 'relative' }}
      >
        <LayersControl collapsed={true} autoZIndex={true} >
          <BaseLayersComponent />
          <InitialPositionButton flyToPosition={props.flyToPosition} flyToZoom={props.flyToZoom} />
        </LayersControl>
        {/* <Watermark /> */}
      </MapContainer >
    </>
  )
}
